import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModaliteReunion } from 'src/app/shared/models/modaliteReunion';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class ModaliteReunionService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllModaliteReunion(): Observable<ModaliteReunion[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.modaliteReunionUrl}/all`,
			'getAllModaliteReunion'
		);
	}

	importModaliteReunion(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'modaliteReunion.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.modaliteReunionUrl}/import`,
			`importModaliteReunion`,
			formData
		);
	}

	getModaliteReunionById(id: number): Observable<ModaliteReunion> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.modaliteReunionUrl}/get/${id}`,
			'getModaliteReunionById'
		);
	}

	updateModaliteReunion(modaliteReunion: ModaliteReunion): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.modaliteReunionUrl}/update/${modaliteReunion.id}`,
			'updateModaliteReunion',
			modaliteReunion
		);
	}

	addModaliteReunion(modaliteReunion: ModaliteReunion): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.modaliteReunionUrl}/add`,
			'addModaliteReunion',
			modaliteReunion
		);
	}

	deleteModaliteReunion(modaliteReunionId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.modaliteReunionUrl}/delete/${modaliteReunionId}`,
			`deleteModaliteReunion`
		);
	}
}
